module.exports = __webpack_public_path__ + "static/media/icon-select-white.caf8715b.svg";